module.exports = __webpack_public_path__ + "img/LogoHuawei.651c98ee.svg";